module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/sniff-seo-bg-header-d-1200.abf45824e96aa702.jpg"+" 1200w"+","+"https://static.sniffspot.com/packs/img/sniff-seo-bg-header-d-1723.58b249b5d3b43f92.jpg"+" 1723w",
        images: [{path: "https://static.sniffspot.com/packs/img/sniff-seo-bg-header-d-1200.abf45824e96aa702.jpg",width: 1200,height: 438},{path: "https://static.sniffspot.com/packs/img/sniff-seo-bg-header-d-1723.58b249b5d3b43f92.jpg",width: 1723,height: 629}],
        src: "https://static.sniffspot.com/packs/img/sniff-seo-bg-header-d-1723.58b249b5d3b43f92.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/sniff-seo-bg-header-d-1723.58b249b5d3b43f92.jpg"},
        
        width: 1723,
        height: 629
      }